import DramaCard from './DramaCard';

function DramaRow({ dramas, title, onOpenModal }) {
    if (!dramas || dramas.length === 0) return null;

    return (
        <section className="drama-section" style={{ display: 'block' }}>
            {title && <h3 className="row-title">{title}</h3>}
            <div className="row-scroller">
                {dramas.map((drama) => (
                    <div key={drama.id || drama.bookId} className="row-card">
                        <DramaCard
                            drama={drama}
                            onOpenModal={onOpenModal}
                            isComingSoon={title?.toLowerCase().includes('akan')}
                        />
                    </div>
                ))}
            </div>
        </section>
    );
}

export default DramaRow;
